import axios from 'axios';

const axiosDBClient = () => {
  const defaultOptions = {
    baseURL: `${process.env.REACT_APP_API_HOST}/api/`,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    config.headers.qlikCookie = localStorage.getItem('qlikCookie');

    return config;
  });

  return instance;
};

export default axiosDBClient();
